export const FLAG_GETTING_SECURITY_PROFILES = 'FLAG_GETTING_SECURITY_PROFILES';
export const GET_SECURITY_PROFILES = 'GET_SECURITY_PROFILES';
export const CLEAR_SECURITY_PROFILES = 'CLEAR_SECURITY_PROFILES';
export const FLAG_SECURITY_PROFILE_ACTIVITY = 'FLAG_SECURITY_PROFILE_ACTIVITY';
export const GET_SECURITY_PROFILE = 'GET_SECURITY_PROFILE';
export const CLEAR_SECURITY_PROFILE = 'CLEAR_SECURITY_PROFILE';
